import {
  AcademicCapIcon,
  ChartBarIcon,
  ChatBubbleLeftRightIcon,
  ClockIcon,
  CpuChipIcon,
  DocumentCheckIcon,
  ShieldCheckIcon,
  SparklesIcon,
  UserGroupIcon,
} from '@heroicons/react/24/outline'
import React from 'react'

const FeaturesSection: React.FC = () => {
  const features = [
    {
      icon: CpuChipIcon,
      title: 'Provider Matching',
      description:
        'Match students with qualified therapy providers based on service requirements, specialty, location, school assignment, and availability.',
    },
    {
      icon: ChatBubbleLeftRightIcon,
      title: 'Provider Outreach Workflows',
      description:
        'Coordinate provider outreach with templated communication, response tracking, and clear next steps throughout the service request lifecycle.',
    },
    {
      icon: ShieldCheckIcon,
      title: 'FERPA Compliant',
      description:
        'Secure handling of student PII and educational data with enterprise-grade security features and full FERPA compliance.',
    },
    {
      icon: AcademicCapIcon,
      title: 'IEP Service Context',
      description:
        'Keep student service details, requested disciplines, frequencies, school context, and individualized needs connected to each assignment decision.',
    },
    {
      icon: ChartBarIcon,
      title: 'Real-time Analytics',
      description:
        'Complete visibility into service case lifecycle with detailed analytics and reporting for informed decision making.',
    },
    {
      icon: SparklesIcon,
      title: 'Special Education Automation',
      description:
        'Replace manual spreadsheet processes for special education therapy staffing with workflows that scale across schools and providers.',
    },
    {
      icon: ClockIcon,
      title: 'Time Savings',
      description:
        'Reduce administrative overhead by 80% with automated matching, scheduling, and communication workflows.',
    },
    {
      icon: DocumentCheckIcon,
      title: 'Compliance Management',
      description:
        'Built-in compliance tracking ensures all regulatory requirements are met with automatic documentation and audit trails.',
    },
    {
      icon: UserGroupIcon,
      title: 'Provider Network',
      description:
        'Build a searchable provider network with disciplines, specialties, locations, availability, and assignment history to improve every student match.',
    },
  ]

  return (
    <section id="features" className="section-padding bg-white">
      <div className="container-padding">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-secondary-900 mb-4">
            Therapy Matching Software for Special Education Teams
          </h2>
          <p className="text-xl text-secondary-600 max-w-3xl mx-auto">
            Transform student-provider matching with secure automation and operational visibility
            designed for school therapy services.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="group card hover:scale-105 transition-all duration-300">
              <div className="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <feature.icon className="w-6 h-6 text-primary-600" />
              </div>
              <h3 className="text-xl font-semibold text-secondary-900 mb-3">{feature.title}</h3>
              <p className="text-secondary-600">{feature.description}</p>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center mt-16">
          <button
            onClick={() => {
              const element = document.getElementById('contact')
              element?.scrollIntoView({ behavior: 'smooth' })
            }}
            className="btn-primary text-lg px-8 py-4"
          >
            Request a Demo Today
          </button>
        </div>
      </div>
    </section>
  )
}

export default FeaturesSection
